import { Button, Checkbox, Modal, Text } from "@mantine/core"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { OrderActionCard } from "../order/order-action-card"
import { useSalesActions } from "../order/order-actions"
import { ReasonTooltip } from "../ui"

type Props = {
  opened: boolean
  code: string
  loading?: boolean
  onClose: () => void
  onConfirm: () => void
}

/** Захиалга цуцлах (Ord_SalesModals 2.4.3): ORD_CANCEL, the user acknowledges it cannot be undone. */
export function CancelOrderModal({ opened, code, loading = false, onClose, onConfirm }: Props) {
  const { t } = useTranslation(["supplierSales", "common"])
  const [ack, setAck] = useState(false)
  const { permissionState } = useSalesActions()
  const perm = permissionState("cancel")

  // Parents close the modal by flipping `opened` after a successful cancel (onClose never runs),
  // so reset the acknowledgement here; the next order must be acknowledged again.
  useEffect(() => {
    if (!opened) setAck(false)
  }, [opened])

  const close = () => {
    setAck(false)
    onClose()
  }

  return (
    <Modal opened={opened} onClose={close} withCloseButton={false} padding={0} size={480} radius="lg" centered>
      <OrderActionCard
        title={t("supplierSales:sales.modals.cancel.title")}
        onClose={close}
        loading={loading}
        footer={
          <>
            <Button variant="default" onClick={close}>{t("common:actions.dismiss")}</Button>
            <ReasonTooltip reason={perm.reason ?? (ack ? null : t("supplierSales:sales.modals.cancel.needAck"))}>
              <Button onClick={onConfirm}>{t("supplierSales:sales.cancel")}</Button>
            </ReasonTooltip>
          </>
        }
      >
        <Text fz={14}>{t("supplierSales:sales.modals.cancel.body", { code })}</Text>
        <Checkbox checked={ack} onChange={(e) => setAck(e.currentTarget.checked)} label={t("supplierSales:sales.modals.cancel.ack")} />
      </OrderActionCard>
    </Modal>
  )
}
